import React from "react";
import { education } from "../data/portfolio";

const EducationWindow = () => {
  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-sunken-thin m-2 flex items-center gap-2 px-2 py-1 text-xs">
        <span aria-hidden="true">🎓</span>
        C:\JAKOB\MY DOCUMENTS\EDUCATION
      </div>

      <div className="flex-1 space-y-3 overflow-auto px-2 pb-2">
        {education.map((item) => (
          <article key={item.degree} className="win-raised p-3">
            <div className="flex flex-wrap gap-2">
              <span className="win-sunken-thin px-2 py-1 text-[11px] font-bold uppercase tracking-wide">
                {item.status}
              </span>
              <span className="win-sunken-thin px-2 py-1 text-[11px] font-bold uppercase tracking-wide text-win-navy">
                {item.period}
              </span>
            </div>
            <h3 className="mt-3 text-xl font-black leading-tight sm:text-2xl">{item.degree}</h3>
            <p className="mt-1 text-sm font-bold text-[#404040]">{item.school}</p>
            <p className="mt-3 text-sm leading-6">{item.description}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default EducationWindow;
